export const PZ_KYC_FIX_ENUM = {
  kycFixHeading: "KYC Fix",
  guid: "Guid",
  name: "Name",
  created: "Created",
  updated: "Updated",
  kycStatus: "KYC Status",
  resolveButton: "Resolve",
};
